import _toConsumableArray from "/home/runner/_work/dataschoolv2/dataschoolv2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useId as n } from "react";
import { DefaultMap as f } from '../utils/default-map.js';
import { createStore as u } from '../utils/store.js';
import { useIsoMorphicEffect as c } from './use-iso-morphic-effect.js';
import { useStore as l } from './use-store.js';
var p = new f(function () {
  return u(function () {
    return [];
  }, {
    ADD: function ADD(r) {
      return this.includes(r) ? this : [].concat(_toConsumableArray(this), [r]);
    },
    REMOVE: function REMOVE(r) {
      var e = this.indexOf(r);
      if (e === -1) return this;
      var t = this.slice();
      return t.splice(e, 1), t;
    }
  });
});
function x(r, e) {
  var t = p.get(e),
    i = n(),
    h = l(t);
  if (c(function () {
    if (r) return t.dispatch("ADD", i), function () {
      return t.dispatch("REMOVE", i);
    };
  }, [t, r]), !r) return !1;
  var s = h.indexOf(i),
    o = h.length;
  return s === -1 && (s = o, o += 1), s === o - 1;
}
export { x as useIsTopLayer };